import React from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import { FaLock, FaBalanceScale } from 'react-icons/fa';
import security_sec from "../feature/odpc.webp";
import FaqCon from './FaqCon';

const SecuritySection = () => {
  return (
    <>
    <section className='bg-lblue mt-5 fade-section' style={{ padding: '60px 0' }}>
      <Container>
        <div className='row m-4 align-items-center'>
          <div className='col-12 mb-3'>
              <h1 className="mb-3 text-left fw800">
                  <b>
                      Built with security{" "}
                      <span className="bg-gold-yellow">at its core</span> 
                  </b>
              </h1>
              <p className='text-left font1 mw700 mb-0' style={{ color: '#666' }}>
                Your customer data is protected with modern security standards and full regulatory compliance — so you can focus on growing your business.
              </p>
          </div>
          {/* LEFT SIDE (CARDS) */}
          <div className='col-12 col-lg-8'>

              <Card className="mb-3 border-0 shadow-sm mt-3">
                  <Card.Body className="d-flex align-items-center">
                      <FaLock size={36} color="#0070ff" className="me-3" />
                      <div>
                          <h6 className="fw-bold mb-1 font9">Enterprise-grade encryption</h6>
                          <p className="text-muted mb-0 font8">
                              All data is encrypted in transit and at rest using industry-standard protocols.
                          </p>
                      </div>
                  </Card.Body>
              </Card>

              <Card className="mb-3 border-0 shadow-sm">
                  <Card.Body className="d-flex align-items-center">
                      <FaBalanceScale size={36} color="#0070ff" className="me-3" />
                      <div>
                          <h6 className="fw-bold mb-1 font9">Compliant by design</h6>
                          <p className="text-muted mb-0 font8">
                              Kadhr is aligned with ODPC data protection standards, ensuring lawful and responsible data handling.
                          </p>
                      </div>
                  </Card.Body>
              </Card>

          </div>

          {/* RIGHT SIDE (IMAGE) */}
          <div className='col-12 col-lg-4 text-center'>

              <div className="p-3" style={{
                  background: "#fff",
                  borderRadius: "16px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
              }}>
                  <Image 
                      src={security_sec} 
                      alt="Kadhr Data Protection Certificate"
                      className="img-fluid"
                      style={{ maxHeight: "150px", objectFit: "contain" }}
                  />
              </div>

          </div>

      </div>
      </Container>
    </section>                
    <FaqCon/>
    </>
  );
};

export default SecuritySection;
